/**
 * API Configuration
 */

// In production, the API is served from Azure App Service
// In development, connect directly to backend to avoid proxy buffering SSE
const isDev = import.meta.env.DEV;
export const API_BASE_URL = import.meta.env.VITE_API_URL || (isDev ? 'http://localhost:3847' : '');

export const endpoints = {
  chat: `${API_BASE_URL}/api/chat`,
  chatStream: `${API_BASE_URL}/api/chat/stream`,
  conversations: `${API_BASE_URL}/api/chat/conversations`,
  documents: `${API_BASE_URL}/api/documents`,
  health: `${API_BASE_URL}/health`,
};
